import { Agriculture, Grass, InfoOutlined, LibraryBooks, Thunderstorm } from '@mui/icons-material';
import { Box, Link, Stack, Typography } from '@mui/material';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Icon from '/@/components/icon';
import { _ } from '/@/locale';
import { getSessionLanguage } from '/@/store/session/selectors';
import { trackEvent } from '/@/store/tracking';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import { timeSince } from '/@/utils';
import styles from './styles.module.css';

const Notification = ({ unreaded, notification, closePopover, markAsRead, markAsClicked, isNotLast }) => {
    const notificationConfig = [
        {
            key: 'my_fields',
            icon: <Agriculture color='primary' sx={{ width: '20px' }} />,
            label: _('Mis lotes'),
            color: 'green-light',
        },
        {
            key: 'crop_monitoring',
            icon: <Grass color='primary' sx={{ width: '20px' }} />,
            label: _('Seguimiento de cultivo'),
            color: 'orange',
        },
        {
            key: 'library',
            icon: <LibraryBooks color='primary' sx={{ width: '20px' }} />,
            label: _('Biblioteca'),
            color: 'blue',
        },
        {
            key: 'weather',
            icon: <Thunderstorm color='primary' sx={{ width: '20px' }} />,
            label: _('Clima'),
            color: 'blue',
        },
        {
            key: 'recommendation',
            icon: (
                <Icon
                    type='recommendationCheck'
                    size='xxs'
                    className={styles['color-blue']}
                    padding={false}
                    sx={{ p: '2px' }}
                />
            ),
            label: _('Recomendaciones'),
            color: 'blue',
        },
        {
            key: 'grower',
            icon: <InfoOutlined color='primary' sx={{ width: '20px' }} />,
            label: _('Productor'),
            color: 'blue',
        },
    ];

    const language = useSelector(getSessionLanguage);
    const history = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const dispatch = useDispatch();
    const notificationData = notificationConfig.find((n) => {
        return n.key === notification.content.category;
    });

    const date = new Date(notification.createdAt).getTime();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleNotificationClick = async () => {
        if (notification.content.path) {
            mpTrackEvent('Notification redirection', {
                notification_type: notification.content.category,
                redirect_destination: notification.content.path,
            });

            if (notificationData.key === 'crop_monitoring') {
                dispatch(trackEvent({ key: 'cropMonitoring.open' }));
            }

            if (closePopover) {
                closePopover();
            }
            await markAsClicked(notification._id);
            history(notification.content.path);
        }
    };

    const readNotification = () => {
        markAsRead(notification._id);
        mpTrackEvent('Read notification', {
            notification_type: notification.content.category,
        });
        handleClose();
    };

    return (
        <Stack className='mp-mask' direction='row'>
            <Stack
                direction='row'
                spacing={1.5}
                sx={{
                    p: 1,
                    ...(Boolean(notification.content.path) && { cursor: 'pointer' }),
                }}
                onClick={handleNotificationClick}
            >
                <Box
                    sx={{
                        '& svg': {
                            width: '20px',
                            height: '20px',
                        },
                        p: '2px',
                    }}
                >
                    {notificationData?.icon}
                </Box>
                <Stack spacing={1.5}>
                    <ReactMarkdown
                        components={{
                            p: ({ children }) => (
                                <Typography
                                    variant='caption'
                                    color={unreaded ? 'primary' : 'primary.mui.inactive'}
                                    component='span'
                                >
                                    {children}
                                </Typography>
                            ),
                            strong: ({ children }) => (
                                <Typography
                                    variant='caption'
                                    color={unreaded ? 'primary' : 'primary.mui.inactive'}
                                    component='span'
                                    fontWeight='bold'
                                >
                                    {children}
                                </Typography>
                            ),
                        }}
                    >
                        {_(notification.content.content)}
                    </ReactMarkdown>
                    <Box>
                        <Typography variant='caption' color='primary.mui.disabled'>
                            <Typography variant='caption' fontWeight='bold' component='span'>
                                <Link>{notificationData?.label}</Link>
                            </Typography>
                            - {timeSince(new Date(date), language)}
                        </Typography>
                    </Box>
                </Stack>
            </Stack>
        </Stack>
    );
};

export default Notification;
